import { t } from "@/i18n-js/instance";
import type { ConfirmationCardProps } from "../../../types/ChatCard";
import { AccessGroupConfirmationCard } from "./ConfirmationCards/AccessGroupConfirmationCard";
import { CommunitySegmentConfirmationCard } from "./ConfirmationCards/CommunitySegmentConfirmationCard";
import { InviteLinkConfirmationCard } from "./ConfirmationCards/InviteLinkConfirmationCard";
import { MemberConfirmationCard } from "./ConfirmationCards/MemberConfirmationCard";
import { ProfileFieldConfirmationCard } from "./ConfirmationCards/ProfileFieldConfirmationCard";
import { SpaceConfirmationCard } from "./ConfirmationCards/SpaceConfirmationCard";
import { SpaceGroupConfirmationCard } from "./ConfirmationCards/SpaceGroupConfirmationCard";
import { TagConfirmationCard } from "./ConfirmationCards/TagConfirmationCard";

type ComponentRenderer = (params: Record<string, unknown>) => JSX.Element;

const CONFIRMATION_CARD_COMPONENTS: Record<string, ComponentRenderer> = {
  title_community_member: params => (
    <MemberConfirmationCard
      name={params.name as string}
      email={params.email as string}
    />
  ),
  title_space_group: params => (
    <SpaceGroupConfirmationCard
      name={params.name as string}
      member_count={params.member_count as number}
    />
  ),
  title_space: params => (
    <SpaceConfirmationCard
      name={params.name as string}
      space_group={params.space_group as string}
      type={params.type as string}
      access={params.access as string}
    />
  ),
  title_invitation_link: params => (
    <InviteLinkConfirmationCard
      name={params.name as string}
      status={params.status as string}
      members_joined_count={params.members_joined_count as number}
    />
  ),
  title_member_tag: params => (
    <TagConfirmationCard
      name={params.name as string}
      is_public={params.is_public as boolean}
    />
  ),
  title_access_group: params => (
    <AccessGroupConfirmationCard
      name={params.name as string}
      description={params.description as string}
      member_count={params.member_count as number}
    />
  ),
  title_profile_field: params => (
    <ProfileFieldConfirmationCard
      label={params.label as string}
      field_type={params.field_type as string}
    />
  ),
  title_community_segment: params => (
    <CommunitySegmentConfirmationCard
      title={params.title as string}
      people_count={params.people_count as number}
    />
  ),
};

export const ConfirmationCard = ({ title, params }: ConfirmationCardProps) => {
  const titleKey = Object.keys(t("help_widget.copilot.confirmation_card")).find(
    key => t(`help_widget.copilot.confirmation_card.${key}`) === title,
  );

  if (!titleKey) {
    return null;
  }

  const renderer = CONFIRMATION_CARD_COMPONENTS[titleKey];
  if (!renderer) {
    return null;
  }

  return renderer(params as Record<string, unknown>);
};
